import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FinesService } from 'src/app/core/services/fines.service';

@Component({
  selector: 'app-fines-detail',
  templateUrl: './fines-detail.component.html',
  styleUrls: ['./fines-detail.component.css']
})
export class FinesDetailComponent implements OnInit {

  isArabic!: boolean;
  @Input() finesList: any;
  userData: any;
  form!: FormGroup;
  finesDetail: any[] = [];
  finesId?: string;  
  totalFines: number = 0;
  finesHistorical?: boolean;
  calculatedFinesDetail: any[] = [];

  constructor(private router: Router, private storageService: StorageService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private finesService: FinesService
  ) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.finesHistorical = this.storageService.getSessionStorageData('finesHistorical');
    this.form = this.fb.group({
      fines: ['']
    });

   
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as { finesId?: string, finesHistorical?: boolean  };
    this.finesId = state?.finesId || 
    history.state?.finesId || 
    this.storageService.getSessionStorageData('finesId');

    this.finesHistorical = state?.finesHistorical || 
    history.state?.finesHistorical || 
    this.storageService.getSessionStorageData('finesHistorical');

    // prepare API payload
    const requestData = {
      finesId: this.finesId,
      finesHistorical: this.finesHistorical
    };
    if(this.finesHistorical){
      this.finesService.fetchFinesHistoricalDetail(requestData).subscribe(
      (res) => {
        if (res?.data) {
          const decryptedData = this.commonService.decryptUsingAES256(res?.data);
          this.finesDetail = JSON.parse(JSON.stringify(decryptedData));
          // Calculate total fines here
          const finesObj = this.finesDetail?.[0]?.mde_Violation;
          if (finesObj) {
            this.totalFines =
              (Number(finesObj.mde_1stwarningfines) || 0) +
              (Number(finesObj.mde_2ndwarningremediationtimeframefines) || 0) +
              (Number(finesObj.mde_3rdwarningandsuspensionperiodfines) || 0);
          }
        }
      },
      (error: any) => {
        console.error('Error fetching fines detail', error);
      }
    );
    }else{
      this.finesService.fetchFinesDetail(requestData).subscribe(
      (res) => {
        if (res?.data) {
          const decryptedData = this.commonService.decryptUsingAES256(res?.data);
          const ACTIVE_STATUS_CODE = 755020000;
          const DRAFT_STATUS_CODE = 755020003; 

          const filteredActiveRecords = decryptedData.filter((item: { mde_enforcementstatus: number; }) => 
            item.mde_enforcementstatus === ACTIVE_STATUS_CODE || 
            item.mde_enforcementstatus === DRAFT_STATUS_CODE
          );
          this.finesDetail = JSON.parse(JSON.stringify(filteredActiveRecords));
          
          this.calculatedFinesDetail = [];
          let cumulativeFineTotal = 0;
          let cumulativeWaivedTotal = 0;

          // Sort the array by Warning level (W1, W2, W3) to ensure correct summation order
          const sortedFines = this.finesDetail.sort((a, b) => {
              const aNum = Number(a.mde_name.replace('Warning', ''));
              const bNum = Number(b.mde_name.replace('Warning', ''));
              return aNum - bNum;
          });


          sortedFines.forEach(fine => {
              // 1. Get the incremental amounts
              const fineAmount = this.safeParse(fine.mde_totalfineammount);
              const waivedAmount = this.safeParse(fine.mde_waivedoffamount);
              
              // 2. Calculate the running totals
              cumulativeFineTotal += fineAmount;
              cumulativeWaivedTotal += waivedAmount;

              // 3. Store the result in the new array
              this.calculatedFinesDetail.push({
                  ...fine, // Copy all original data
                  cumulativeTotal: cumulativeFineTotal,
                  cumulativeWaived: cumulativeWaivedTotal
              });
          });
        }
      },
      (error: any) => {
        console.error('Error fetching fines detail', error);
      }
    );
    }
  }

  subscribeToEmitter(componentRef: any) {
    // if (!(componentRef instanceof  AssessmentSelectComponent)) {
    //   return;
    // }
    // const child: any = componentRef;


  }

  onListItemClick(selectedItemIdx: number) {
    this.finesList.forEach((v: any, i: any) => {
      if (i === selectedItemIdx) {
        v.isActive = true;
      } else {
        v.isActive = false;
      }
    });
    if (this.finesList[selectedItemIdx].link !== '') {
      let path = 'executor-dashboard/' + this.finesList[selectedItemIdx].link;
      this.router.navigate([path]);
    }
  }
  private safeParse(value: string | null | undefined): number {
  if (!value || value === 'null') return 0; // Handle 'null' string explicitly
  return Number(value) || 0;
  }
}
